'use client';

import { cn } from '@/lib/utils';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { CustomChangeLayout } from '../custom-change-layout/custom-change-layout';
import { Button, ButtonProps } from '../ui/button';

export default function ThemeToggle(props: ButtonProps) {
    const { setTheme, theme } = useTheme();

    return (
        <CustomChangeLayout
            legacyComponent={null}
            modernComponent={
                <Button
                    variant='secondary'
                    size='icon'
                    {...props}
                    className={cn('rounded-full', props.className)}
                    onClick={() =>
                        setTheme(theme === 'dark' ? 'light' : 'dark')
                    }
                >
                    <SunIcon className='w-5 rotate-90 scale-0 transition-transform duration-500 ease-in-out dark:rotate-0 dark:scale-100' />
                    <MoonIcon className='scale-1000 absolute w-5 rotate-0 transition-transform duration-500 ease-in-out dark:-rotate-90 dark:scale-0' />
                    <span className='sr-only'>Switch Theme</span>
                </Button>
            }
        />
    );
}
